import API from 'src/api'
import { http } from '../boot/axios'

export default {
  GRAPHQL_URL: `${API.GRAPHQL_URL}`,
  getRolesByUser ({organization_id, isOnAdmin, restrictToUserFranchises}) {
    const params = { isOnAdmin }
    if (restrictToUserFranchises) params.restrict_to_user_franchises = true

    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}role/fetch/${organization_id}?limit=999`, { params })
        .then(response => {
          resolve(response.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  fetch (role_id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}role/${role_id}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  delete (role_id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}role/${role_id}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  createNewNode (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}newNode/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  getNodes (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}getTree/${payload.id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  getNodesByFranchise (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}getTrees`, { params: payload })
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  removeNode (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}removeNode/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  editNode (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}editNode/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  createRole (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}role/`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  updateRole (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}role/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  getRole (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}role/${payload.id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  roleByFranchise (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}roleByFranchise/${payload.id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  roleByOrganization (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}rolesByOrganization/${payload.id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  getAvailableReviewerRoles (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}availableReviewerRoles`, { params: payload })
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchRolesHierarchy () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}fetchRolesHierarchy`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  }
}
